import React, { useMemo } from 'react';
import { MdModeEditOutline, MdOutlineDeleteOutline } from 'react-icons/md';
import Button from '../../components/shared/buttons/Button';
import Row from '../../components/shared/table/Row';
import SelectableRow from '../../components/shared/table/SelectableRow';
import Table from '../../components/shared/table/Table';

const BrandsTable = ({ brands, loading, onBrandClick, onBrandEditClick, onBrandDeleteClick, readOnly }) => {
  const tableRows = useMemo(
    () =>
      brands.map((brand, i) => (
        <SelectableRow key={i} onClick={() => onBrandClick(brand)}>
          <Row children={brand.name} />
          {!readOnly && (
            <Row
              children={
                <div className="flex items-center gap-2">
                  <div title="Редагувати" className="w-full text-end z-10">
                    <Button
                      onClick={(event) => {
                        event.stopPropagation();
                        onBrandEditClick(brand);
                      }}
                      variant="secondary2"
                      disabled={loading}
                    >
                      <MdModeEditOutline size={20} />
                    </Button>
                  </div>
                  <div title="Видалити" className="w-full text-end z-10">
                    <Button
                      onClick={(event) => {
                        event.stopPropagation();
                        onBrandDeleteClick(brand);
                      }}
                      variant="secondary2"
                      disabled={loading}
                    >
                      <MdOutlineDeleteOutline size={20} />
                    </Button>
                  </div>
                </div>
              }
            />
          )}
        </SelectableRow>
      )),
    [onBrandEditClick, onBrandClick, readOnly, onBrandDeleteClick, loading, brands],
  );

  return <Table columns={readOnly ? readOnlyColumns : columns} data={tableRows} onRowClick={() => ({})} />;
};

const readOnlyColumns = [{ name: 'Назва', className: 'w-[100%]' }];

const columns = [
  { name: 'Назва', className: 'w-[95%]' },
  { name: 'Дії', className: 'w-[5%] text-center' },
];

export default BrandsTable;
